export default __webpack_public_path__ + "static/media/discover.8ef84c62.svg";